<template>
  <div class="drawer-wrapper" :class="{ open }">
    <div class="modal" @click="onClickModal"></div>
    <div class="outer">
      <div @click.stop class="drawer">
        <div class="header">
          <div class="drawer-title">{{ title }}</div>
          <div
            v-if="showClose"
            @click="$emit('close')"
            class="drawer-close"
          ></div>
        </div>
        <div class="body">
          <slot> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["close"],
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
    closeOnClickModal: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "标题",
    },
  },
  methods: {
    onClickModal() {
      if (this.closeOnClickModal) this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-wrapper {
  &.open {
    .modal {
      opacity: 1;
      z-index: 1000;
    }
    .outer {
      opacity: 1;
      z-index: 1000;
      .drawer {
        pointer-events: all;
        transform: translateY(0);
        transition: 0.3s;
        z-index: 1001;
      }
    }
  }

  .modal {
    position: fixed;
    opacity: 0;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.75);
    z-index: -1;
    transition: 0.2s;
  }
  .outer {
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
    .drawer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      transform: translateY(30rem);
      margin: 0 auto;
      background: #fff;
      padding: 0.5rem 2rem 2rem 2rem;
      border-radius: 1.2rem 1.2rem 0 0;
      min-height: 30rem;
      box-sizing: border-box;
      .header {
        height: 4rem;
        display: flex;
        position: relative;
        align-items: center;
        justify-content: center;
        .drawer-title {
          letter-spacing: 0.2em;
          font-size: 1.7rem;
          font-weight: bold;
        }
        .drawer-close {
          position: absolute;
          right: 1rem;
          top: 0.5rem;
          height: 1rem;
          width: 1rem;
          background: url(../../assets/close.png) no-repeat center;
          background-size: contain;
          cursor: pointer;
        }
      }
      .body {
        width: 100%;
      }
    }
  }
}
</style>
